import React, { useContext, useEffect, useState } from "react"
import { NavLink, useLocation } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons"
import "./Header.css"

import { Helmet } from "react-helmet"

import { AppContext } from "../shared/context/AppContext"

// Online bedrijfsuitje is hidden until the page is ready
const NAV_ITEMS = [
  // Also active on an escape room's info and pay pages
  { to: "/escaperooms", label: "Escape rooms", labelEN: "Escape rooms" },
  {
    to: "/custom_escape_room",
    label: "Escape room op maat",
    labelEN: "Custom escape room",
  },
  { to: "/faq", label: "FAQ", labelEN: "FAQ" },
]

// The active menu item follows the address, so it can never go stale. Pages
// that are not in the menu (like /rankings/<name>) simply highlight nothing.
function Header() {
  const { language, setLanguage, dotcom } = useContext(AppContext)
  const [menuOpen, setMenuOpen] = useState(false)
  const location = useLocation()
  const nl = language === "NL"
  const current = NAV_ITEMS.find((item) =>
    location.pathname.startsWith(item.to)
  )

  // Close the mobile menu after navigating
  useEffect(() => {
    setMenuOpen(false)
  }, [location.pathname])

  const pickLanguage = (lang) => {
    setLanguage(lang)
    try {
      window.localStorage.setItem("langPicked", lang)
    } catch {}
  }

  return (
    <header className="site-header">
      {/* Tells browsers, screen readers and search engines the page language */}
      <Helmet htmlAttributes={{ lang: nl ? "nl" : "en" }} />
      <div className="site-header-inner">
        {/* On phones the bar shows where you are, next to the menu button */}
        <span className="current-page" aria-hidden="true">
          {current ? (nl ? current.label : current.labelEN) : ""}
        </span>

        <button
          type="button"
          className="menu-toggle"
          aria-expanded={menuOpen}
          aria-controls="site-nav"
          aria-label="Menu"
          onClick={() => setMenuOpen((open) => !open)}
        >
          <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
        </button>

        <nav
          id="site-nav"
          className={`site-nav${menuOpen ? " open" : ""}`}
          aria-label={nl ? "Hoofdmenu" : "Main menu"}
        >
          <ul>
            {NAV_ITEMS.map((item) => (
              <li key={item.to}>
                {/* The span carries the hover background, the link the underline */}
                <NavLink to={item.to} activeClassName="active">
                  <span>{nl ? item.label : item.labelEN}</span>
                </NavLink>
              </li>
            ))}
          </ul>

          {!dotcom && (
            <div
              className="language-toggle"
              role="group"
              aria-label={nl ? "Taal" : "Language"}
            >
              <button
                type="button"
                aria-pressed={nl}
                onClick={() => pickLanguage("NL")}
              >
                NL
              </button>
              <button
                type="button"
                aria-pressed={!nl}
                onClick={() => pickLanguage("EN")}
              >
                EN
              </button>
            </div>
          )}
        </nav>
      </div>
    </header>
  )
}

export default Header
